/* eslint-disable no-case-declarations */
import {
  useState, useEffect, useRef, useContext,
} from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../juristec-ui/core/Tooltip';
import Button from '../../../juristec-ui/core/Button';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import IconButton from '../../../juristec-ui/core/IconButton';
import Select2 from '../../../juristec-ui/core/SelectNew';
import Select from '../../../juristec-ui/core/Select';

import {
  optionNamespace,
  GroupOptions,
  useKpiModifiers,
  useModifierConfig,
  TypePeriodOptions,
} from '../../../hooks/modifiers';

import {
  Close, UploadImage,
} from '../../../juristec-ui/icons';

import {
  CreateReportContainer,
  FormColumns,
  FormColumn,
  FormLine,
  InputWrapper,
  ImageContainer,
  ImagePreview,
  ImageCheckbox,
  ImageOptions,
  CheckboxInputWrapper,
  TabGroup,
  TabButton,
  StyledContentTab,
  ModifiersContainer,
  LabelSmall,
  SegregateSection,
  SegregateTitle,
  SegregateDescription,
  SegregateSelectWrapper,
} from './styled/ExtractReport.styled';
import {
  ChoiceBoxController,
  SimpleColorPickerController,
} from '../../../juristec-ui/kpis/controllers/Base';

import Checkbox from '../../../juristec-ui/core/Checkbox';
import SelectTips from '../../Popovers/SelectTips';
import KpiFilter from '../../KpiFilter';
import KpiFilterApplied from '../../KpiFilterApplied';
import { AlertContext } from '../../../context/AlertProvider';
import { dateOptions } from '../../../options';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';
import { verifyFileName } from '../../../juristec-ui/utils/validators/inputTextValidators';

const generateReportDefaultPropFiles = [];
const generateReportDefaultPropTourContext = {
  tourOpen: false, nextStep: () => {}, remakeTourList: () => {},
};
const generateReportDefaultPropClose = () => {};
const generateReportDefaultPropCheckImage = () => {};
const generateReportDefaultPropGenerateReport = () => {};

/**
* A component to inform the attributes of a new dashboard
*/
const GenerateReport = ({
  files = generateReportDefaultPropFiles,
  getColumns,
  fetchFileSampleData,
  getUnique,
  close = generateReportDefaultPropClose,
  tourContext = generateReportDefaultPropTourContext,
  checkImage = generateReportDefaultPropCheckImage,
  generateReport = generateReportDefaultPropGenerateReport,
}) => {
  const { t } = useTranslation();
  const { setAlertConfig } = useContext(AlertContext);
  const [tab, setTab] = useState('general');
  const [selectedFile, setSelectedFiles] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [noImage, setNoImage] = useState(false);
  const [includeDate, setIncludeDate] = useState(true);
  const [reportImage, setReportImage] = useState('');
  const [segregateBy, setSegregateBy] = useState(null);
  const [groupBy, setGroupBy] = useState(null);
  const [aggFunc, setAggFunc] = useState(null);
  const [aggColumns, setAggColumns] = useState(null);
  const [outputFormat, setOutputFormat] = useState({ label: 'Excel', value: 'xlsx', id: 'xlsx' });
  // const [imgFile, setImgFile] = useState(null);
  const [dataFrame, setDataFrame] = useState(null);
  const [dataFrameOptions, setDataFrameOptions] = useState([]);

  const [generateBtnDisabled, setGenerateBtnDisabled] = useState(true);
  const [extractedReportFilename, setExtractedReportFilename] = useState({
    value: '', errorMsg: 'O nome do arquivo não pode estar vazio!', error: true,
  });
  const [imageBlob, setImageBlob] = useState(null);

  // Configuração para estilos
  const [config, setConfig] = useState({
    lineColorControl: 'single',
    rowColor: '',
    secondaryRowColor: '',
    headerColor: '',
    groupedRowColor: '',
  });

  const inputFile = useRef(null);

  // Função auxiliar para validar se um array está contido em outro
  const isArrayContainedInArray = (arrayToCheck, containerArray) => {
    if (!arrayToCheck || !Array.isArray(arrayToCheck)) return true;
    if (!containerArray || !Array.isArray(containerArray)) return false;
    return arrayToCheck.every(
      (item) => containerArray.some((container) => container.value === item.value),
    );
  };
  // Função auxiliar para verificar se um tipo é numérico
  const isNumericType = (colValue) => {
    if (!dataFrame?.types || !colValue) return false;
    const type = dataFrame?.types?.[colValue];
    if (!type) return false;
    return type.includes('float');
  };

  // Função auxiliar para validar se todas as colunas especificadas estão nas colunas selecionadas
  const validateColumnsAgainstSelected = () => {
    // Se nenhuma coluna foi selecionada, usar todas as colunas do arquivo
    const columnsToUse = selectedColumns.length > 0 ? selectedColumns : fileColumns;

    // Validar coluna separadora
    if (
      (segregateBy && segregateBy.value)
      && !columnsToUse.some((c) => c.value === segregateBy.value)
    ) {
      return false;
    }

    // Validar colunas de agrupamento
    if (groupBy && !isArrayContainedInArray(groupBy, columnsToUse)) {
      return false;
    }

    // Validar colunas de agregação
    if (aggColumns && !isArrayContainedInArray(aggColumns, columnsToUse)) {
      return false;
    }

    // Validar colunas de expansão
    return true;
  };

  const handleName = (value) => {
    const val = value.split(' ').filter((v) => v).join('');
    const msg = verifyFileName(val);
    setExtractedReportFilename({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  // const {
  //   // Filter state and handlers
  //   filterConfig,
  //   filterValuesOptions,
  //   filtersToSend,
  //   handleFilterConfig,
  //   handleFilterChange,
  //   addFilter,
  //   removeFilter,
  //   editFilter,
  //   changeFilterOrder,
  //   getTypeOptions,
  //   checkValsModifiers,
  // } = useKpiModifiers({
  //   dataFrameTypes: dataFrame?.types || {},
  //   getUniqueValues: getUnique,
  //   selectedDatabase: { value: selectedFile.id },
  //   onModifierChange: () => setGenerateBtnDisabled(false),
  // });

  const getUniqueValues = (column, selector) => (
    getUnique(selectedFile.id, column, selector)
  );

  const {
    modifierConfig,
    simpleOptions,
    getColumnOptions,
    getSimpleOptions,
    handleModifierConfigs,
    resetModifierConfigs,
    //
    configColumnIsDate,
    getOptionsByConfigGroup,
    checkModifierValues,
  } = useModifierConfig({
    dataFrameTypes: dataFrame?.types || {},
    modifierOrigins: { filters: 'Filtro' },
    getUniqueValues,
  });

  const handleModifierChange = () => {
    setGenerateBtnDisabled(false);
  };

  const {
    modifiers,
    addModifier,
    removeModifier,
    editModifier,
    changeModifierOrder,
  } = useKpiModifiers({
    dataFrameTypes: dataFrame?.types || {},
    initialModifiers: { filters: [] },
    onModifierChange: handleModifierChange,
  });

  const handleColumnSelect = (selected) => handleModifierConfigs({ column: selected });
  const handleGroupSelect = (selected) => handleModifierConfigs({ group: selected });
  const handleSelectorSelect = (selected) => handleModifierConfigs({ selector: selected });
  const handleFormatSelect = (selected) => handleModifierConfigs({ format: selected });
  const handleFilterChange = (values) => handleModifierConfigs({ values });

  const handleAddModifier = () => {
    addModifier(modifierConfig);
    resetModifierConfigs();
  };

  // Validar os campos de agrupamento e as validações de colunas
  useEffect(() => {
    // Verifica se algum campo de agrupamento está preenchido
    const hasGrouping = groupBy && groupBy.length > 0;
    const hasAggFunc = aggFunc !== null;
    const hasAggColumns = aggColumns && aggColumns.length > 0;
    // Validar se as colunas especificadas estão contidas nas colunas selecionadas
    const columnsAreValid = validateColumnsAgainstSelected();
    if (selectedColumns?.length === 0) {
      setGenerateBtnDisabled(true);
    }
    // Se algum campo estiver preenchido, todos devem estar
    if (hasGrouping || hasAggFunc || hasAggColumns) {
      const allFilled = hasGrouping && hasAggFunc && hasAggColumns;

      if (!allFilled || !columnsAreValid) {
        setGenerateBtnDisabled(true);
      } else {
        setGenerateBtnDisabled(false);
      }
    } else if (!columnsAreValid) {
      // Se não há agrupamento mas colunas inválidas, desabilitar
      setGenerateBtnDisabled(true);
    } else {
      setGenerateBtnDisabled(false);
    }
  }, [groupBy, aggFunc, aggColumns, selectedColumns, segregateBy, fileColumns]);

  const handleStyleConfig = (currentConfig, key, value) => ({ ...currentConfig, [key]: value });

  const handleStyleChanges = (value, diff) => {
    setConfig(handleStyleConfig(config, diff, value));
  };
  // ============================================
  // ATUALIZAÇÃO DA FUNÇÃO handleSubmit
  // ============================================

  const handleSubmit = async () => {
    const hasGrouping = groupBy && groupBy.length > 0;
    const hasAggFunc = aggFunc !== null;
    const hasAggColumns = aggColumns && aggColumns.length > 0;

    // Validar se as colunas especificadas estão contidas nas colunas selecionadas
    if (!validateColumnsAgainstSelected()) {
      setAlertConfig({
        type: 'error',
        text: 'Todas as colunas selecionadas para separar, agrupar, agregar e expandir devem estar contidas nas colunas selecionadas do relatório.',
      });
      return;
    }

    // Determinar quais colunas enviar: se selecionadas estão preenchidas, usar; senão usar todas
    const columnsToSend = selectedColumns.length > 0
      ? selectedColumns.map((c) => c.value)
      : fileColumns.map((c) => c.value);

    // Prepara os dados de agrupamento
    const groupingConfig = hasGrouping && hasAggFunc && hasAggColumns ? {
      groupBy: groupBy.map((c) => c.value),
      aggFunc: aggFunc.value,
      aggColumns: aggColumns.map((c) => c.value),
    } : null;

    // Prepara os dados de configuração de cores opcionais
    const stylingConfig = {
      headerColor: config.headerColor || null,
      rowColor: config.rowColor || null,
      secondaryRowColor: config.secondaryRowColor || null,
      groupedRowColor: (hasGrouping && config.groupedRowColor) ? config.groupedRowColor : null,
    };
    // console.log(stylingConfig);
    await generateReport(
      selectedFile.id,
      outputFormat.value,
      reportImage !== '' ? imageBlob : null,
      modifiers,
      includeDate,
      columnsToSend,
      extractedReportFilename.value,
      segregateBy?.value ?? null,
      groupingConfig,
      stylingConfig,
    );
  };

  // Adicione este useEffect para limpar campos relacionados quando necessário:
  useEffect(() => {
    if (!groupBy || groupBy.length === 0) {
      setAggFunc(null);
      setAggColumns(null);
      handleStyleConfig('groupedRowColor', null);
    }
  }, [groupBy]);

  useEffect(() => {
    if (!aggFunc) {
      setAggColumns(null);
    }
  }, [aggFunc]);

  // const handleImgPick = (url) => {
  //   setImgFile(url);
  //   setReportImage(url);
  //   setColors((p) => ({ ...p, mainColor: '' }));
  // };

  // Update handleUpload to store both the blob and preview URL
  const handleUpload = (e) => {
    URL.revokeObjectURL(reportImage);
    const file = e.target.files[0];
    if (file && checkImage(file)) {
      setImageBlob(file); // Store the actual file/blob
      setReportImage(URL.createObjectURL(file)); // Store URL for preview
      if (tourContext.tourOpen) tourContext.nextStep();
    }
  };

  const removeImg = () => {
    URL.revokeObjectURL(reportImage);
    setReportImage('');
    setImageBlob(null);
  };

  // Update cleanup useEffect
  useEffect(() => () => {
    URL.revokeObjectURL(reportImage);
  }, []);

  useEffect(() => {
    if (selectedFile?.value) {
      setGenerateBtnDisabled(false);
    }
  }, [selectedFile]);

  const handleNoImage = () => {
    const state = !noImage;
    if (state) removeImg();
    setNoImage(!noImage);
  };

  const fetchAndSetFileSampleData = async (page = 0, stateSort = { field: 'index', order: 0 }, pageSize = 20, fileId) => {
    const {
      error: er, msg, raw, tempArray, newDT,
    } = await fetchFileSampleData(page, stateSort, pageSize, fileId);
    if (er) {
      // goBack();
      setAlertConfig({
        type: 'error',
        text: msg,
        child: raw,
      });
      // goBack();
    } else {
      // setfileLength((res.total_pages - 1) * pageSize);
      setDataFrameOptions(tempArray);
      // setDataFrameDescription(res.description);
      setDataFrame(newDT);
    }
  };

  const handleSelectedFiles = async (selected) => {
    setSelectedFiles(selected);
    const columns = await getColumns(selected.id);
    await fetchAndSetFileSampleData(0, { field: 'index', order: 0 }, 20, selected.id);
    setFileColumns(columns);
    setSelectedColumns(columns);
  };

  return (
    <>
      <TabGroup>
        <TabButton active={tab === 'general'} onClick={() => setTab('general')}>
          <span>Geral</span>
        </TabButton>
        <TabButton
          active={tab === 'filter'}
          onClick={() => setTab('filter')}
          title="Selecione os Filtros para o seu relatório"
          disabled={selectedFile.length === 0}
        >
          <span>Filtros</span>
        </TabButton>
        <TabButton
          active={tab === 'advanced'}
          onClick={() => setTab('advanced')}
          title="Opções avançadas de configuração do relatório"
          disabled={selectedFile.length === 0}
        >
          <span>Avançado</span>
        </TabButton>
        <TabButton
          active={tab === 'styles'}
          onClick={() => setTab('styles')}
          title="Opções de estilo do relatório"
          disabled={selectedFile.length === 0}
        >
          <span>
            Estilos
          </span>
        </TabButton>
      </TabGroup>
      <CreateReportContainer>
        {tab === 'general' && (
          <>
            <FormColumns>
              <FormColumn>
                <FormLine>
                  <InputWrapper>
                    <Select2
                      options={files.map((f) => (
                        {
                          value: f.file_id, label: f.filename, id: f.file_id, ...f,
                        }
                      ))}
                      onChange={handleSelectedFiles}
                      value={selectedFile}
                      atModal
                      searchable
                      sortBy="ascending"
                      label="Selecione o arquivo"
                    />
                  </InputWrapper>
                </FormLine>
                <FormLine>
                  <InputWrapper disabled={selectedFile.length === 0}>
                    <Select2
                      options={fileColumns}
                      onChange={setSelectedColumns}
                      value={selectedColumns}
                      atModal
                      searchable
                      label="Selecione as colunas"
                      multiple
                      sortBy="ascending"
                      stayOpen
                      selectAll
                    />
                  </InputWrapper>
                </FormLine>
                <FormLine>
                  <InputWrapper>
                    <Select2
                      label="Formato de saída"
                      atModal
                      onChange={(newValue) => setOutputFormat(newValue)}
                      value={outputFormat}
                      options={[
                        { label: 'Excel', value: 'xlsx', id: 'xlsx' },
                        { label: 'Pdf', value: 'pdf', id: 'pdf' },
                        { label: 'Documento do Word', value: 'docx', id: 'docx' },
                      ]}
                    />
                  </InputWrapper>
                </FormLine>
                <FormLine style={{ margin: 'auto 0' }}>
                  <CheckboxInputWrapper>
                    <Checkbox
                      text="Adicionar data de criação"
                      color="primary"
                      variant="outlined"
                      checked={includeDate}
                      handleCheckboxChange={() => setIncludeDate(!includeDate)}
                    />
                  </CheckboxInputWrapper>
                </FormLine>
              </FormColumn>
              <FormColumn>
                <ImageContainer>
                  <input
                    type="file"
                    ref={inputFile}
                    accept="image/*"
                    onChange={handleUpload}
                    style={{ display: 'none' }}
                  />
                  <ImagePreview
                    style={{ backgroundImage: `url(${reportImage})`, opacity: noImage ? '0.3' : '1' }}
                  />
                  <ImageOptions>
                    <Tooltip
                      text="Adicionar nova imagem"
                      direction="left"
                      atModal
                      className={noImage ? 'option-disabled' : ''}
                    >
                      <IconButton
                        onClick={() => inputFile.current.click()}
                        color="secondary"
                        variant="contained"
                        shape="rounded"
                        size="medium"
                        className="image_trigger"
                      >
                        <UploadImage />
                      </IconButton>
                    </Tooltip>
                    {reportImage.length > 0 && (
                      <Tooltip text="Remover imagem atual" direction="right" atModal>
                        <IconButton
                          onClick={removeImg}
                          color="white"
                          size="medium"
                          shape="rounded"
                          className="fix-icon"
                        >
                          <Close />
                        </IconButton>
                      </Tooltip>
                    )}
                    <ImageCheckbox>
                      <Checkbox
                        text="Sem imagem"
                        color="primary"
                        variant="outlined"
                        checked={noImage}
                        handleCheckboxChange={handleNoImage}
                      />
                    </ImageCheckbox>
                  </ImageOptions>
                </ImageContainer>
              </FormColumn>
            </FormColumns>
            <FormLine style={{ marginTop: '10px' }}>
              <InputTextLine
                label="Nome do relatório *"
                value={extractedReportFilename.value}
                placeholder="Digite o nome"
                errorMessage={extractedReportFilename.errorMsg}
                error={extractedReportFilename.errorMsg.length > 0}
                onChange={(e) => handleName(e.target.value)}
              />
            </FormLine>
          </>
        )}
        {tab === 'filter' && (
          <StyledContentTab className="kpi-side-content-tab">
            <div className="gap-fix-first">
              <div className="gap-fix-second">
                <div style={{ width: '50%' }}>
                  <Select2
                    label="Filtrar por"
                    onChange={handleColumnSelect}
                    value={modifierConfig.column}
                    options={getColumnOptions({ filters: dataFrameOptions })}
                    atModal
                    searchable
                    clearable
                    sortBy="ascending"
                  />
                </div>
                <div style={{ width: '50%' }}>
                  <Select2
                    label="Tipo"
                    onChange={handleGroupSelect}
                    value={modifierConfig.group}
                    options={GroupOptions.list}
                    optionNamespace={optionNamespace}
                    atModal
                  />
                </div>
              </div>
              {(modifierConfig.column?.value?.length ?? 0) > 0 && (
                <>
                  <div className="gap-fix-second">
                    {modifierConfig.group.value === GroupOptions.enum.SIMPLE
                    && configColumnIsDate() && (
                      <div style={{ width: '100%' }}>
                        <Select2
                          label="Formato"
                          onChange={handleSelectorSelect}
                          value={modifierConfig.selector}
                          options={dateOptions}
                          searchable
                          atModal
                        />
                      </div>
                    )}
                    <div style={{ position: 'relative', width: '100%' }}>
                      <Select2
                        label="Condição"
                        onChange={handleFormatSelect}
                        value={modifierConfig.format}
                        options={getOptionsByConfigGroup()}
                        optionNamespace={optionNamespace}
                        searchable
                        atModal
                      />
                      {modifierConfig.format.value !== '' && (
                        <SelectTips
                          description={t(modifierConfig.format.description, {
                            ns: optionNamespace,
                            ...(modifierConfig.format.params ?? {}),
                          })}
                          style={{ top: '-5px', right: '2px', zIndex: 1050 }}
                        />
                      )}
                    </div>
                  </div>
                  {modifierConfig.format?.value.length > 0 && (
                    modifierConfig.group?.value === GroupOptions.enum.ADVANCED
                    || simpleOptions.length > 0
                  ) && (
                    <>
                      {!Object.keys(TypePeriodOptions.map).includes(
                        modifierConfig.format.value,
                      ) && (
                        <KpiFilter
                          filterType={modifierConfig.format.value}
                          handle={handleFilterChange}
                          values={modifierConfig.values}
                          options={getSimpleOptions(modifiers)}
                          format={modifierConfig.column?.type}
                          atModal
                        />
                      )}
                      <Button
                        onClick={handleAddModifier}
                        color="secondary"
                        disabled={!checkModifierValues()}
                        style={{ margin: '10px 0 10px', width: '100%' }}
                      >
                        Adicionar filtro
                      </Button>
                    </>
                  )}
                </>
              )}
            </div>
            {modifiers.filters?.length > 0 && (
              <ModifiersContainer>
                <LabelSmall>Filtros Aplicados</LabelSmall>
                {modifiers.filters?.map((filter, i) => (
                  <KpiFilterApplied
                    key={filter.uid}
                    origin="filters"
                    modifier={filter}
                    modifiers={modifiers}
                    removeFunc={removeModifier}
                    editFunc={editModifier}
                    getOptions={getUniqueValues}
                    dataFrameTypes={dataFrame.types}
                    position={i}
                    isLast={modifiers.filters.length - 1 === i}
                    changePosition={changeModifierOrder}
                    atModal
                  />
                ))}
              </ModifiersContainer>
            )}
          </StyledContentTab>
        )}
        {tab === 'advanced' && (
          <>
            <SegregateSection>
              <SegregateTitle>Separação por abas (opcional)</SegregateTitle>
              <SegregateDescription>
                <strong>O que faz:</strong>
                {' '}
                Divide seu relatório em abas separadas
                {' '}
                baseado nos valores únicos de uma coluna escolhida.
                <br />
                <br />
                <strong>Quando usar:</strong>
                {' '}
                Utilize quando quiser organizar dados por
                {' '}
                categorias (ex: por região, departamento, status).
                <br />
                <br />
                <strong>Limite de abas:</strong>
                {' '}
                Se a coluna tiver mais de
                {' '}
                <strong>20 valores únicos</strong>
                , o sistema criará
                <strong> 22 abas</strong>
                : as 20 mais frequentes + uma aba chamada
                {' '}
                <strong>OUTROS</strong>
                {' '}
                com os valores restantes e uma aba chamada
                {' '}
                <strong>TODOS</strong>
                {' '}
                com o relatório completo.
                <br />
                <br />
                <strong>Exemplo:</strong>
                {' '}
                Se você selecionar a coluna &quot;Estado&quot;,
                {' '}
                terá uma aba para cada estado (SP, RJ, MG, etc).
              </SegregateDescription>
              <SegregateSelectWrapper>
                <Select2
                  selectLabel="Coluna separadora"
                  atModal
                  clearable
                  searchable
                  placeholder="Selecione a coluna para separar os valores únicos em abas"
                  onChange={(newValue) => setSegregateBy(newValue)}
                  value={segregateBy}
                  options={selectedColumns}
                  fullWidth
                  title="Selecione a coluna cujos valores únicos criarão as abas"
                />
              </SegregateSelectWrapper>
            </SegregateSection>
            <SegregateSection>
              <SegregateTitle>Agrupamento e Agregação (opcional)</SegregateTitle>
              <SegregateDescription>
                <strong>O que faz:</strong>
                {' '}
                Agrupa dados por colunas selecionadas e
                {' '}
                calcula valores agregados (soma, contagem, etc).
                <br />
                <br />
                <strong>Como funciona:</strong>
                {' '}
                A primeira linha do relatório mostrará os
                {' '}
                dados agrupados com os valores agregados. As linhas
                seguintes mostram todos os dados detalhados originais para referência.
                <br />
                <br />
                <strong>Quando usar:</strong>
                {' '}
                Quando você precisa ver o resumo dos dados
                {' '}
                (totalizações, contagens) mas mantendo os detalhes originais
                disponíveis.
                <br />
                <br />
                <strong>Exemplo:</strong>
                {' '}
                Agrupar por &quot;Departamento&quot; e
                {' '}
                somar &quot;Vendas&quot; resultaria em uma linha com o total de
                vendas por departamento.
              </SegregateDescription>

              {/* Seletor de colunas para agrupar */}
              <SegregateSelectWrapper>
                <div style={{ marginBottom: '8px' }}>
                  <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>
                    1. Escolha as colunas para agrupar
                  </span>
                </div>
                <Select2
                  options={selectedColumns}
                  onChange={(value) => {
                    setGroupBy(value);
                  }}
                  value={groupBy}
                  atModal
                  searchable
                  label="Agrupar por"
                  placeholder="Selecione colunas para agrupar"
                  multiple
                  sortBy="ascending"
                  stayOpen
                  title="Selecione uma ou mais colunas para agrupar seus dados"
                />
              </SegregateSelectWrapper>

              {/* Seletor de função de agregação */}
              {groupBy && groupBy.length > 0 && (
                <SegregateSelectWrapper style={{ marginTop: '15px' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>
                      2. Escolha a função de agregação
                    </span>
                  </div>
                  <Select
                    selectLabel="Função de agregação"
                    atModal
                    placeholder="Selecione a função"
                    onChange={(newValue) => {
                      setAggFunc(newValue);
                    }}
                    value={aggFunc}
                    options={[
                      {
                        label: 'Soma - Calcula o total dos valores',
                        value: 'sum',
                        id: 'sum',
                        description: 'Soma todos os valores na coluna selecionada',
                      },
                      {
                        label: 'Contagem - Conta quantos registros existem',
                        value: 'count',
                        id: 'count',
                        description: 'Conta quantos registros há em cada grupo',
                      },
                      {
                        label: 'Listagem (Array) - Lista todos os valores',
                        value: 'list',
                        id: 'list',
                        description: 'Cria uma lista com todos os valores encontrados',
                      },
                    ]}
                    fullWidth
                    title="Selecione como os valores serão agregados"
                  />
                </SegregateSelectWrapper>
              )}

              {/* Seletor de colunas para aplicar a agregação */}
              {aggFunc && (
                <SegregateSelectWrapper style={{ marginTop: '15px' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>
                      3. Escolha as colunas para aplicar a agregação
                    </span>
                  </div>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <Select2
                      options={selectedColumns.filter((col) => {
                        // Excluir colunas que estão em groupBy
                        if (groupBy.some((g) => g.value === col.value)) return false;
                        // Se aggFunc é 'sum', filtrar apenas colunas numéricas
                        if (aggFunc.value === 'sum') return isNumericType(col.value);
                        return true;
                      })}
                      onChange={(value) => {
                        setAggColumns(value);
                      }}
                      value={aggColumns}
                      atModal
                      searchable
                      label="Aplicar função de agregação em"
                      placeholder="Selecione colunas para agregar"
                      multiple
                      sortBy="ascending"
                      stayOpen
                      title="Selecione as colunas onde a função de agregação será aplicada"
                    />
                    {aggFunc.value === 'sum' && (
                      <SelectTips
                        description="📌 Apenas colunas numéricas são mostradas para soma"
                        style={{ top: '7px', right: '2px', zIndex: 1050 }}
                      />
                    )}
                  </div>
                </SegregateSelectWrapper>
              )}
            </SegregateSection>
          </>
        )}
        {tab === 'styles' && (
          <>
            <SegregateSection>
              <SegregateTitle>Personalização de Cores (Opcional)</SegregateTitle>
              <SegregateDescription>
                Se desejar, personalize as cores de fundo para o documento extraído.
                Deixe vazio para utilizar as cores padrão.
              </SegregateDescription>

              <div style={{
                display: 'flex', flexDirection: 'column',
              }}
              >
                <SimpleColorPickerController
                  label="Cor do cabeçalho"
                  handle={handleStyleChanges}
                  kWord="headerColor"
                  configValue={config?.headerColor}
                  orientation="row"
                  fullWidth
                  text="Configuração da cor do cabeçalho do relatório"
                />
                <ChoiceBoxController
                  label="Cor das linhas"
                  handle={handleStyleChanges}
                  kWord="lineColorControl"
                  options={[
                    { value: 'single', label: 'Cor única', id: 'single' },
                    { value: 'striped', label: 'Intercalada', id: 'striped' },
                  ]}
                  configValue={config?.lineColorControl || 'single'}
                  fullWidth
                  text="Configuração de cores das linhas do relatório"
                />
                <div style={{
                  display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
                }}
                >
                  <SimpleColorPickerController
                    label="Primária"
                    handle={handleStyleChanges}
                    kWord="rowColor"
                    configValue={config?.rowColor}
                    orientation="row"
                    fullWidth={config?.lineColorControl !== 'striped'}
                    text="Configuração da cor primária de fundo das linhas do relatório"
                  />
                  {config?.lineColorControl === 'striped' && (
                    <SimpleColorPickerController
                      label="Secundária"
                      handle={handleStyleChanges}
                      kWord="secondaryRowColor"
                      configValue={config?.secondaryRowColor}
                      orientation="row"
                      text="Configuração da cor secundária de fundo das linhas do relatório"
                    />
                  )}
                </div>

                {
                  groupBy
                  && groupBy.length > 0
                  && aggFunc
                  && aggColumns
                  && aggColumns.length > 0
                  && (
                    <div style={{
                      marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '12px',
                    }}
                    >
                      <span style={{
                        fontSize: '13px', color: '#666', fontWeight: '500', marginBottom: '-4px',
                      }}
                      >
                        Cores Específicas para Agrupamento:
                      </span>
                      <SimpleColorPickerController
                        label="Cor das linhas agrupadas"
                        handle={handleStyleChanges}
                        kWord="groupedRowColor"
                        configValue={config?.groupedRowColor}
                        orientation="row"
                        fullWidth
                        text="Cor do consolidado das linhas agrupadas (ex: total por pedidos)"
                      />
                    </div>
                  )
                }
              </div>
            </SegregateSection>
          </>
        )}
      </CreateReportContainer>

      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          disabled={
            extractedReportFilename.errorMsg.length > 0 || generateBtnDisabled
            || selectedFile.length === 0 || selectedColumns.length === 0
          }
          size="large"
        >
          Gerar
        </Button>
      </ActionsGroup>
    </>
  );
};

GenerateReport.propTypes = {
  /**
    * Array with the names of the current groups
    */
  files: PropTypes.arrayOf(),
  /**
    * Function to get file columns
    */
  getColumns: PropTypes.func.isRequired,
  /**
    * Function to get info from file
    */
  fetchFileSampleData: PropTypes.func.isRequired,
  /**
    * Function to get unique values from column
    */
  getUnique: PropTypes.func.isRequired,
  /**
   * Function to close the modal or toggle the component visibility
   */
  close: PropTypes.func,

  tourContext: PropTypes.shape({
    tourOpen: PropTypes.bool,
    nextStep: PropTypes.func,
    remakeTourList: PropTypes.func,
  }),
  /**
  *  Function to check if an image satisfies the desired conditions
  */
  checkImage: PropTypes.func,
  /**
   * Function to generate the report
   */
  generateReport: PropTypes.func,
};

export default GenerateReport;
